import React from 'react';

import { Button, Text } from '@change/ds-core-ui';

import { Translate } from '@change-corgi/core/react/i18n';

import { useCtaSection } from './hooks';

export const CtaSection: React.FC = () => {
	const {
		actions: { trackSapClick },
	} = useCtaSection();

	return (
		<div
			className="bg-gradient-background-dark-3 text-typography-inverse-strong flex flex-col rounded-xl p-6 max-lg:gap-10 md:flex-row md:items-center md:justify-between"
			data-qa="topic-sitemap-cta"
		>
			<Text as="h2" variant="heading" size="small">
				<Translate value="corgi.topic_page_sitemap.cta.cta_section_text" />
			</Text>
			<Button
				data-qa="sidebar-sap-button"
				as="a"
				href="/start-a-petition/intro?source_location=topic-sitemap"
				variant="primary"
				onClick={trackSapClick}
			>
				<Translate value="corgi.topic_page_sitemap.cta.cta_button" />
			</Button>
		</div>
	);
};
